/*
 * CreateSurveyModal Messages
 *
 * This contains all the text for the CreateSurveyModal component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  chooseFrom: {
    id: 'app.components.CreateSurveyModal.chooseFrom',
    defaultMessage: 'Choose from a selection of question types and features',
  },
  hireAResearcher: {
    id: 'app.components.CreateSurveyModal.hireAResearcher',
    defaultMessage: 'Work with an expert',
  },
  buildSurvey: {
    id: 'app.components.CreateSurveyModal.buildSurvey',
    defaultMessage: 'Build it yourself',
  },
  projectSettings: {
    id: 'app.components.CreateSurveyModal.projectSettings',
    defaultMessage: 'Project settings',
  },
  projectName: {
    id: 'app.components.CreateSurveyModal.projectName',
    defaultMessage: 'Project name',
  },
  surveyLanguage: {
    id: 'app.components.CreateSurveyModal.surveyLanguage',
    defaultMessage: 'Survey language',
  },
  surveyTargetHeading: {
    id: 'app.components.CreateSurveyModal.surveyTargetHeading',
    defaultMessage: 'How would you like to collect responses to your survey?',
  },
  recommended: {
    id: 'app.components.CreateSurveyModal.recommended',
    defaultMessage: 'Recommended',
  },
  submit: {
    id: 'app.components.CreateSurveyModal.submit',
    defaultMessage: 'Submit',
  },
  nextStep: {
    id: 'app.components.CreateSurveyModal.nextStep',
    defaultMessage: 'Next',
  },
  nextStepAudience: {
    id: 'app.components.CreateSurveyModal.nextStepAudience',
    defaultMessage: 'Choose your target audience',
  },
  bookYourMeeting: {
    id: 'app.components.CreateSurveyModal.bookYourMeeting',
    defaultMessage: 'Book your meeting',
  },
  bookYourMeetingDesc: {
    id: 'app.components.CreateSurveyModal.bookYourMeetingDesc',
    defaultMessage:
      'Book a free 15 minute meeting with one of our experts to discuss your project needs.',
  },
  acceptYourQuote: {
    id: 'app.components.CreateSurveyModal.acceptYourQuote',
    defaultMessage: 'Accept your quote',
  },
  acceptYourQuoteDesc: {
    id: 'app.components.CreateSurveyModal.acceptYourQuoteDesc',
    defaultMessage:
      "After your meeting, you'll receive a quote. When you're ready, complete your payment to add the expert to your team.",
  },
  approveYourSurvey: {
    id: 'app.components.CreateSurveyModal.approveYourSurvey',
    defaultMessage: 'Approve your survey',
  },
  approveYourSurveyDesc: {
    id: 'app.components.CreateSurveyModal.approveYourSurvey',
    defaultMessage:
      'The expert will lead the survey creation process, then ask you to approve and submit your survey.',
  },
  back: {
    id: 'app.components.CreateSurveyModal.back',
    defaultMessage: 'Back',
  },
  marketPlaceLoadError: {
    id: 'app.components.CreateSurveyModal.marketPlaceLoadError',
    defaultMessage:
      'The researcher calendar could not be loaded. Please try again in a moment.',
  },
  distributionDesc: {
    id: 'app.components.CreateSurveyModal.distributionDesc',
    defaultMessage: 'Create your survey and send a link to your own list.',
  },
  regularSurveyDesc: {
    id: 'app.components.CreateSurveyModal.regularSurveyDesc',
    defaultMessage:
      'Use the Pollfish <strong>global survey network</strong> to reach the right audience for your survey. Starting from $0.95 per complete response.',
  },
  peeqSurveyDesc: {
    id: 'app.components.CreateSurveyModal.peeqSurveyDesc',
    defaultMessage:
      'Use the Pollfish global network to reach the right audience for your survey.',
  },
  settingUpProject: {
    id: 'app.components.CreateSurveyModal.settingUpProject',
    defaultMessage: 'Setting up your project',
  },
  letsTalk: {
    id: 'app.components.CreateSurveyModal.letsTalk',
    defaultMessage: "Let's talk",
  },
  surveyPeeqSelect: {
    heading: {
      id: 'app.components.CreateSurveyModal.surveyPeeqSelect.heading',
      defaultMessage: 'Collector settings',
    },
    selectCountry: {
      id: 'app.components.CreateSurveyModal.surveyPeeqSelect.selectCountry',
      defaultMessage:
        'In which country you want us to target your users? You can change it later.',
    },
    selectCompletes: {
      id: 'app.components.CreateSurveyModal.surveyPeeqSelect.selectCompletes',
      defaultMessage:
        'How many responses would you like to get? You can change it later.',
    },
    fieldRequired: {
      id: `app.components.CreateSurveyModal.surveyPeeqSelect.fieldRequired`,
      defaultMessage: 'This field is required',
    },
  },
  customTermsConditions: {
    toggleTitle: {
      id: `app.components.CreateSurveyModal.customTermsConditions.toggleTitle`,
      defaultMessage: 'Survey Terms & Conditions',
    },
    titlePlaceholder: {
      id: `app.components.CreateSurveyModal.customTermsConditions.titlePlaceholder`,
      defaultMessage: 'Add a title (optional)',
    },
    bodyPlaceholder: {
      id: `app.components.CreateSurveyModal.customTermsConditions.bodyPlaceholder`,
      defaultMessage: 'Add survey terms',
    },
  },
});
